import { render } from "./index-table.vue?vue&type=template&id=34eddefc&scoped=true&ts=true"
import script from "./index-table.vue?vue&type=script&lang=ts"
export * from "./index-table.vue?vue&type=script&lang=ts"

import "./index-table.vue?vue&type=style&index=0&id=34eddefc&lang=less&scoped=true"
import "./index-table.vue?vue&type=style&index=1&id=34eddefc&lang=less"

import exportComponent from "/builds/workshop/teambition-frontend/node_modules/.pnpm/vue-loader@16.8.3_6zog4g7lmcedlfqueoidvwcx7q/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34eddefc"]])

export default __exports__